export var FnEditorElementType;
(function (FnEditorElementType) {
    FnEditorElementType["SceneHeading"] = "scene-heading";
    FnEditorElementType["Action"] = "action";
    FnEditorElementType["Character"] = "character";
    FnEditorElementType["Parenthetical"] = "parenthetical";
    FnEditorElementType["Dialogue"] = "dialogue";
    FnEditorElementType["Transition"] = "transition";
    FnEditorElementType["Blank"] = "blank";
    FnEditorElementType["Lyrics"] = "lyric";
    FnEditorElementType["CenteredAction"] = "centered-action";
    FnEditorElementType["PageBreak"] = "page-break";
    FnEditorElementType["Synopsis"] = "synopsis";
    FnEditorElementType["Section"] = "section";
})(FnEditorElementType || (FnEditorElementType = {}));
